import type { PriceId } from '@iheartjane/types';
import get from 'lodash-es/get';

import type { AlgoliaProduct } from '@jane/search/types';
// eslint-disable-next-line no-restricted-imports
import type { MenuProduct } from '@jane/shared/models';
import type {
  MaterializedMenuProduct,
  PendingCartProduct,
} from '@jane/shared/types';

export const getMaxCartQuantity = (
  menuProduct:
    MenuProduct | AlgoliaProduct | PendingCartProduct | MaterializedMenuProduct,
  weight: PriceId
) => {
  return (
    get(
      menuProduct,
      `max_cart_quantity_${weight}`,
      menuProduct.max_cart_quantity
    ) || menuProduct.max_cart_quantity
  );
};
